import { postSecondStageVotesFx } from "../lib/effects/postSecondStageVotesFx/postSecondStageVotesFx"
import { combine, createEvent, createStore, sample } from "effector"
import { createGate } from "effector-react"
import { messagesTypes, setMessage } from "src/entity/Messages"
import { $secondStageVotes } from "src/entity/Pretendents"
import { $userId } from "src/entity/User"
import { openFinalPanelAfterPostFx } from "src/shared/lib/effects/openFinalPanelAfterPostFx/openFinalPanelAfterPostFx"

export const PostSecondStageVotesGate = createGate()

export const $isPending = createStore<boolean>(false)

export const postSecondStageVotesTrigger = createEvent()
const $normalizedSecondStageVotes = combine({
  votes: $secondStageVotes,
  userId: $userId,
})

// sample({
//   clock: postSecondStageVotesTrigger,
//   source: $normalizedSecondStageVotes,
//   filter: $normalizedSecondStageVotes => !!$normalizedSecondStageVotes.votes,
//   target: postSecondStageVotesFx
// });

// sample({
//   clock: postSecondStageVotesTrigger,
//   source: $normalizedSecondStageVotes,
//   filter: $normalizedSecondStageVotes => !$normalizedSecondStageVotes.votes,
//   fn: () => messagesTypes.FILL_ERROR,
//   target: setMessage
// });

// sample({
//   clock: postSecondStageVotesFx.pending,
//   target: $isPending
// });

// sample({
//   clock: postSecondStageVotesFx.fail,
//   fn: () => messagesTypes.POST_ERROR,
//   target: setMessage
// });

// sample({
//   clock: postSecondStageVotesFx.doneData,
//   target: openFinalPanelAfterPostFx
// });
